export const ADD_BLOCK_MIN_WEEKS = 1;
export const ADD_BLOCK_MAX_WEEKS = 24;
export const ADD_BLOCK_DEFAULT_WEEKS = 6;

export const normalizeWeeksValue = (value) => {
  const parsedValue = Number.parseInt(value, 10);
  if (!Number.isFinite(parsedValue)) return ADD_BLOCK_DEFAULT_WEEKS;
  if (parsedValue < ADD_BLOCK_MIN_WEEKS) return ADD_BLOCK_MIN_WEEKS;
  if (parsedValue > ADD_BLOCK_MAX_WEEKS) return ADD_BLOCK_MAX_WEEKS;
  return parsedValue;
};

export const resolveWeeksForSave = (value) => normalizeWeeksValue(value);

export const incrementWeeksValue = (value) =>
  normalizeWeeksValue(resolveWeeksForSave(value) + 1);

export const decrementWeeksValue = (value) =>
  normalizeWeeksValue(resolveWeeksForSave(value) - 1);

export const sanitizeWeeksInputDraft = (value) =>
  String(value ?? "")
    .replace(/\D/g, "")
    .slice(0, 2);

export const resolveWeeksDraftOnBlur = (value) =>
  String(resolveWeeksForSave(value));

export const normalizeFolderLabel = (value) =>
  typeof value === "string" ? value.trim() : "";
